module.exports = __webpack_public_path__ + "static/media/new-horizons-logo.ee6b4980.png";